export default __webpack_public_path__ + "static/google-play-en-4a1a6402018f61c804637e8480030fa1.png";